var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("path", {
    d: "M28,25c0.9-1.2,1.6-2.5,2.1-3.9c0-0.1,0.1-0.2,0.1-0.4c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.2,0.1-0.4,0.2-0.6 c0-0.2,0.1-0.4,0.1-0.6c0.1-0.3,0.1-0.6,0.1-0.8c0-0.2,0-0.3,0.1-0.5c0-0.5,0.1-0.9,0.1-1.4c0-8.3-6.7-15-15-15S1,7.7,1,16 c0,0.5,0,0.9,0.1,1.4c0,0.2,0,0.3,0.1,0.5c0,0.3,0.1,0.6,0.1,0.8c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.2,0.1,0.5,0.2,0.7c0,0.1,0.1,0.2,0.1,0.4C2.4,22.5,3.1,23.8,4,25v0l0,0c2.7,3.6,7.1,6,12,6S25.2,28.6,28,25L28,25L28,25z  M16,29c-4.6,0-8.6-2.4-10.9-6c1.6-2.6,4.1-4.5,7.1-5.4C10.8,16.5,10,14.8,10,13c0-3.3,2.7-6,6-6s6,2.7,6,6c0,1.8-0.8,3.5-2.1,4.6 c2.9,0.9,5.4,2.9,7.1,5.4C24.6,26.6,20.6,29,16,29z",
    id: "id_101",
    style: {
      fill: "rgb(0, 150, 148)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a3ef48a7edd91996e40dbeefb6e2237e.svg";
export { ForwardRef as ReactComponent };